import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=5c40eef2"
import script from "./Canvas.vue?vue&type=script&lang=ts"
export * from "./Canvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports